import { createContext, useContext, useState, ReactNode } from "react";

interface SizePreferenceContextType {
  preferredSize: string | null;
  setPreferredSize: (size: string | null) => void;
  clearPreference: () => void;
  hasAskedPreference: boolean;
  setHasAskedPreference: (asked: boolean) => void;
}

const SizePreferenceContext = createContext<SizePreferenceContextType | undefined>(undefined);

export const SizePreferenceProvider = ({ children }: { children: ReactNode }) => {
  const [preferredSize, setPreferredSizeState] = useState<string | null>(null);
  const [hasAskedPreference, setHasAskedPreferenceState] = useState(false);

  const setPreferredSize = (size: string | null) => {
    setPreferredSizeState(size);
    setHasAskedPreferenceState(true);
  };

  const clearPreference = () => {
    setPreferredSizeState(null);
  };

  const setHasAskedPreference = (asked: boolean) => {
    setHasAskedPreferenceState(asked);
  };

  return (
    <SizePreferenceContext.Provider
      value={{
        preferredSize,
        setPreferredSize,
        clearPreference,
        hasAskedPreference,
        setHasAskedPreference,
      }}
    >
      {children}
    </SizePreferenceContext.Provider>
  );
};

export const useSizePreference = () => {
  const context = useContext(SizePreferenceContext);
  if (!context) {
    throw new Error("useSizePreference must be used within a SizePreferenceProvider");
  }
  return context;
};
